module.exports = __webpack_public_path__ + "img/IMG-truck-bg1.dfe22f78.png";